module.exports = __webpack_public_path__ + "static/media/Page_2.c6eacae8.jpg";